import mutations from "./mutations";
import actions from "./actions";

const state = () => ({
  isLoading: false
});

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
